
import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { User } from 'src/app/model';
import { FileProvider } from 'src/app/providers';
import { UserService } from 'src/app/services';
import { CacheImageService } from 'src/app/services/cache-image.service';

@Component({
  selector: 'custom-avatar',
  templateUrl: './custom-avatar.component.html',
  styleUrls: ['./custom-avatar.component.scss']
})
export class CustomAvatarComponent implements OnInit, OnDestroy {

  userSub: any;
  photoSub: any;

  isLoading = false;
  @Input() id: string;
  @Input() name: string;
  @Input() url: string;
  @Input() size: number;
  @Input() color: string;
  hasAvatar: boolean = false;

  rootUrl: string = "/api/file/users"
  photoUrl: string;
  imageSrc: any;

  constructor(
    public userService: UserService,
    public fileProvider: FileProvider,
    public cacheImageService: CacheImageService
  ) { }

  ngOnInit(): void {

    if (this.url != undefined && this.url != null && this.url.length > 0)  {
      let avatarUrl = this.rootUrl + this.url;
      this.cacheImageService.getImage(this.id, avatarUrl)
        .subscribe(data => {
          this.imageSrc =data
          this.hasAvatar = true;
        }, error => {
          this.hasAvatar = false;
        });
    }
  }

  ngOnDestroy(): void {

  }


}
